import React from "react";
import { useQuery } from "react-query";
//components
import ClickSignSigners from "../../../../../EnterpriseSettings/ClickSign/ClickSignSigners";
//services
import { getUsers } from "../../../../../../../services/GeneralRegistration/getUsers";
import { getTypeSigner } from "../../../../../../../services/Enterprise/ClickSign/getTypeSinger";
import { getConfigContract } from "../../../../../../../services/Enterprise/ClickSign/getConfigContract";
import { postConfigContract } from "../../../../../../../services/Enterprise/ClickSign/postConfigContract";
import { deleteSignersContract } from "../../../../../../../services/Enterprise/ClickSign/deleteSignersContract";
import { useAppContext } from "../../../../../../../context/AppContext";

const Signatory = ({ id, enterpriseId }) => {
  const { permissions } = useAppContext();

  const {
    data: signers,
    refetch: refetchSigners,
    isLoading: isLoadingSigners,
  } = useQuery({
    queryKey: [`signers${id}`],
    queryFn: () => getUsers(),
    enabled: !!permissions?.includes("10")
  });
  const {
    data: registeredSigners,
    refetch: refetchRegisterSigners,
    isLoading: isLoadingRegisterSigners,
  } = useQuery({
    queryKey: [`registeredSigners${id}`],
    queryFn: () => getConfigContract(id),
    enabled: !!permissions?.includes("78")
  });

  const {
    data: config_sign,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: [` ${enterpriseId}`],
    queryFn: () => getTypeSigner(enterpriseId),
    enabled: !!permissions?.includes("78")
  });

  return (
    <>
      <div className="row">
        <ClickSignSigners
          registeredSigners={registeredSigners}
          signers={signers}
          refetchSigners={refetchSigners}
          isLoadingSigners={isLoadingSigners}
          refetchRegisterSigners={refetchRegisterSigners}
          isLoadingRegisterSigners={isLoadingRegisterSigners}
          config_sign={config_sign}
          isLoading={isLoading}
          refetch={refetch}
          {...(permissions && permissions.includes("79") && { sendPost: postConfigContract })} // Cadastrar Signatários no Contrato
          idSale={id}
          {...(permissions && permissions.includes("80") && { deleteSigners: deleteSignersContract })} //Excluir Signatários  do Contrato
        ></ClickSignSigners>
      </div>
    </>
  );
};

export default Signatory;
